export const CSPUrlsMap = {
  dashboard: {
    url: '/dashboard',
    title: 'Dashboard'
  },
  contactUs: {
    url: '/contact-us',
    title: 'Contact Us'
  },
  myClaims: {
    url: '/claims/my-claims',
    title: 'My Claims'
  },
  newClaim: {
    url: '/claims/make-a-new-claim',
    title: 'Make a New Claim'
  },
  myPets: {
    url: '/my-pets/',
    title: 'My Pets'
  },
  myDocuments: {
    url: '/my-documents',
    title: 'My Documents'
  },
  premPayHistory: {
    url: '/premiums-and-payments/my-premiums-and-payments-history/',
    title: 'Premiums and Payments History'
  },
  payNow: {
    url: '/premiums-and-payments/pay-now/',
    title: 'Pay Now'
  },
  bankDetails: {
    url: '/premiums-and-payments/bank-details/',
    title: 'Bank Details'
  },
  accountDetails: {
    url: '/my-profile/account-details',
    title: 'Account Details'
  },
  vetDetails: {
    url: '/my-profile/vet-details',
    title: 'Vet Details'
  },
  notificationPreferences: {
    url: '/my-profile/notification-preferences',
    title: 'Notification Preferences'
  },
  updateEmail: {
    url: '/my-profile/update-user/email',
    title: 'Update Email'
  },
  updateMobile: {
    url: '/my-profile/update-user/phone',
    title: 'Update Mobile'
  },
  login: {
    url: '/signin',
    title: 'Sign In'
  },
  logout: {
    url: '/signout',
    title: 'Sign Out'
  },
  verification: {
    url: '/verification/',
    title: 'Verification'
  },
  verifyEmail: {
    url: '/verification/verify-email',
    title: 'Verify Email'
  },
  verifySms: {
    url: '/verification/verify-sms',
    title: 'Verify SMS'
  },
  helpCentre: {
    url: '/help-centre/',
    title: 'Help Centre'
  },
  helpCentrePopular: {
    url: '/help-centre/popular-questions/',
    title: 'Help Centre - Popular Questions'
  },
  helpCentreGettingStarted: {
    url: '/help-centre/getting-started/',
    title: 'Help Centre - Getting Started'
  },
  helpCentrePolicyManagement: {
    url: '/help-centre/policy-management/',
    title: 'Help Centre - Policy Management'
  },
  helpCentreClaims: {
    url: '/help-centre/claims/',
    title: 'Help Centre - Claims'
  },
  helpCentrePremiumsPayments: {
    url: '/help-centre/premiums-payments/',
    title: 'Help Centre - Premiums and Payments'
  },
  helpCentrePolicyCoverage: {
    url: '/help-centre/policy-coverage/',
    title: 'Help Centre - Policy Coverage'
  },
  authErrorPage: {
    url: '/autherror',
    title: 'Authentication Error'
  },
  liveVet: {
    url: '/live-vet',
    title: 'Live Vet'
  },
  postConsultation: {
    url: '/postconsultation',
    title: 'Post Consultation'
  },
  uploadRequiredDocuments: {
    url: '/upload-required-documents',
    title: 'Upload Required Documents'
  },
  registration: {
    url: '/CustomerRegister',
    title: 'Register'
  },
  renewalHub: {
    url: '/renewal',
    title: 'Renewal'
  },
  renewalHubConfirmation: {
    url: '/renewal/confirmation',
    title: 'Renewal Confirmation'
  }
};
